import { Reveal } from "./Reveal";
import { ChevronRight } from "lucide-react";

export const FinalCTA = () => {
  return (
    <section data-testid="final-cta-section" className="relative bg-[#050505] py-28 md:py-40 overflow-hidden">
      <div className="absolute inset-x-0 top-0 h-px bg-neutral-800" />
      <div className="absolute -top-40 left-1/2 h-96 w-[60rem] -translate-x-1/2 rounded-full bg-orange-500/10 blur-3xl" />

      <div className="relative z-10 max-w-7xl mx-auto px-5 md:px-8">
        <Reveal>
          <h2
            className="font-display text-5xl md:text-7xl font-bold uppercase tracking-tighter leading-[0.95] text-white"
            data-testid="final-cta-headline"
          >
            You Own The Company.
            <span className="block text-orange-500">We Handle The Operations.</span>
          </h2>
        </Reveal>

        <Reveal delay={0.15}>
          <p className="mt-10 max-w-xl text-base md:text-lg text-neutral-300" data-testid="final-cta-subtext">
            If you've been looking for a way to enter the trucking industry without having to build
            the entire operating infrastructure yourself, let's talk.
          </p>
        </Reveal>

        <Reveal delay={0.3}>
          <div className="mt-12">
            <a
              href="#get-started"
              data-testid="final-cta-button"
              className="inline-flex items-center gap-2 bg-orange-500 px-10 py-6 font-display text-lg md:text-xl font-bold uppercase tracking-wider text-white transition-all duration-200 hover:bg-orange-600 hover:-translate-y-1"
            >
              See If I Qualify
              <ChevronRight size={24} />
            </a>
            <p className="mt-6 text-sm uppercase tracking-[0.2em] text-neutral-500" data-testid="final-cta-note">
              Start with a confidential discovery call.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
